module.exports = __webpack_public_path__ + "static/img/5777_phase_function_Paper_Points.c5f6140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5777_phase_function_Paper_Points.png
// module id = X3YK
// module chunks = 0